import imageCompression from 'browser-image-compression';
import { toNumber, map } from 'lodash-es';
import { startOfYear, setYear } from 'date-fns';
import moment from 'moment';

export function seperateNumbersWithCommas(x) {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
}

export async function compressImage(file, onProgress) {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    onProgress: typeof onProgress === 'function' ? onProgress : () => {},
  };
  const comdfile = await imageCompression(file, options);
  return comdfile;
}

export function isFloat(n) {
  return toNumber(n) === n && n % 1 !== 0;
}

export function sortByMonth(arr) {
  const newArr = arr.map((r) => {
    return {
      ...r,
      SORTKEY: `01/${r?.DATE?.split(' ')[0]}/20${r?.DATE?.split(' ')[1]}`,
    };
  });

  const sortedArr = newArr?.sort(function (a, b) {
    return new Date(a.SORTKEY) - new Date(b.SORTKEY);
  });

  return sortedArr;
}

export function sortByMonthAndYear(arr) {
  const modifiedArray = map(arr, (a) => {
    const [month, year] = a.DATE.split('-');
    const parsedDate = new Date(`${year}-${month}-1`);

    return {
      ...a,
      DATE: parsedDate,
    };
  });
  const sortedArray = modifiedArray?.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.

    return new Date(a.DATE) - new Date(b.DATE);
  });

  const remodifiedOriginalArray = map(sortedArray, (sarr) => {
    return {
      ...sarr,
      DATE: moment(sarr.DATE).format('MM-YYYY'),
    };
  });
  return remodifiedOriginalArray;
}

export function sortByDate(arr) {
  //const originalArray = JSON.parse(JSON.stringify(arr));

  const modifiedArray = map(arr, (a) => {
    const [day, month, year] = a.DATE.split('-');
    const parsedDate = new Date(`${year}-${month}-${day}`);

    return {
      ...a,
      DATE: parsedDate,
    };
  });
  const sortedArray = modifiedArray?.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.

    return new Date(a.DATE) - new Date(b.DATE);
  });

  const remodifiedOriginalArray = map(sortedArray, (sarr) => {
    return {
      ...sarr,
      DATE: moment(sarr.DATE).format('DD-MM-YYYY'),
    };
  });
  return remodifiedOriginalArray;
}

export function generateGranularityBasedDateRange(granularity) {
  let startDate = null;
  let endDate = null;
  if (granularity === 'last_10_days') {
    // startDate = subDays(new Date(), 10).toLocaleDateString();
    startDate = moment().subtract(10, 'd').format('DD/MM/YYYY');
    // endDate = new Date().toLocaleDateString();
    endDate = moment().format('DD/MM/YYYY');
  } else if (granularity === 'monthly') {
    // startDate = startOfYear(new Date()).toLocaleDateString();
    // endDate = new Date().toLocaleDateString();
    startDate = moment()
      .subtract(1, 'years')
      .add(1, 'months')
      .startOf('month')
      .format('DD/MM/YYYY');
    endDate = moment()
      // .subtract(1, 'months')
      // .endOf('month')
      .format('DD/MM/YYYY');
  } else if (granularity === 'yearly') {
    startDate = startOfYear(setYear(new Date(), 2021)).toLocaleDateString();
    endDate = new Date().toLocaleDateString();
  }
  return {
    startDate,
    endDate,
  };
}

export const vehicleTypes = [
  {
    id: '3',
    name: '2 + 3 Wheelers',
  },
  {
    id: '4',
    name: '4 Wheelers',
  },
];

export function localDate(date) {
  if (!(date instanceof Date)) {
    if (Number.isNaN(Date.parse(date))) return 'N/A';
    date = new Date(date);
  }
  const allMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const month = allMonths[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
}

export function getIST(date = false) {
  let currentTime = new Date();
  if (date) {
    currentTime = new Date(date);
  }
  const currentOffset = currentTime.getTimezoneOffset();
  const ISTOffset = 330; // IST offset UTC +5:30
  return new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);
}

export function calculatePageOffset(limit, page) {
  return (page - 1) * limit;
}

export function humanizeDurationnHoursMinutes(nMinutes) {
  const hours = toNumber(nMinutes) / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);

  if (rhours === 0) {
    return {
      string: `${rminutes}m`,
      minutes: rminutes,
      hours: rhours,
    };
  }
  return {
    string: `${rhours}hr ${rminutes}m`,
    hours: rhours,
    minutes: rminutes,
  };
}

export function getTotalNumOfPages(totalRecords, limit) {
  return Math.ceil(toNumber(totalRecords) / toNumber(limit));
}
